// extracted by mini-css-extract-plugin
module.exports = {"widgetWrap":"BannerWidgetWeather_widgetWrap__1bLbW"};